export const utilsService = {
    deepCopy,
    getMonth,
    getValueForTimeUnit,
    getGermanDateText,
    getGermanDateTextTime,
    datesAreOnSameDay,
    formatCurrency
};

function deepCopy(obj) {
    return Object.assign({}, obj);
}

function getMonth(month) {
    let monthText;
    switch (month) {
        case 1:
            monthText = "Januar";
            break;
        case 2:
            monthText = "Februar";
            break;
        case 3:
            monthText = "März";
            break;
        case 4:
            monthText = "April";
            break;
        case 5:
            monthText = "Mai";
            break;
        case 6:
            monthText = "Juni";
            break;
        case 7:
            monthText = "Juli";
            break;
        case 8:
            monthText = "August";
            break;
        case 9:
            monthText = "September";
            break;
        case 10:
            monthText = "Oktober";
            break;
        case 11:
            monthText = "November";
            break;
        case 12:
            monthText = "Dezember";
            break;
        default:
            monthText = "Unbekannter Monat"
    }
    return monthText;
}

function getValueForTimeUnit(unit) {
    let value = 1;
    switch (unit) {
        case "Minutes":
            value = 60 * 1000;
            break;
        case "Hours":
            value = 60 * 60 * 1000;
            break;
        case "Days":
            value = 24 * 60 * 60 * 1000;
            break;
        default:
            value = 60000
    }
    return value;
}

function getGermanDateText(date) {
    return date.getDate() + "." + (date.getMonth()+1) + "." + date.getFullYear();
}

function getGermanDateTextTime(date) {
    let hours = date.getHours();
    if (hours < 10) {
        hours = "0" + hours;
    }
    let minutes = date.getMinutes();
    if (minutes < 10) {
        minutes = "0" +minutes;
    }
    return hours + ":" + minutes;
}

function datesAreOnSameDay(first, second) {
    return first.getFullYear() === second.getFullYear() &&
        first.getMonth() === second.getMonth() &&
        first.getDate() === second.getDate();
}

function formatCurrency(value) {
    let rounded = Math.round(value*100)/100;
    let currencyString = rounded.toString();
    currencyString = currencyString.replace(".", ",");
    if(currencyString.split(",")[1] && currencyString.split(",")[1].length === 1) {
        currencyString += "0";
    }
    currencyString += "€";
    return currencyString;
}

